import { defineComponent as d, openBlock as t, createElementBlock as l, mergeProps as i, unref as o, renderSlot as p, createElementVNode as H, createCommentVNode as u } from "vue";
import { useScalarIcon as L } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, m = { key: 1 }, v = { key: 2 }, M = { key: 3 }, g = { key: 4 }, h = { key: 5 }, f = {
  name: "ScalarIconHouseLine"
}, y = /* @__PURE__ */ d({
  ...f,
  props: {
    label: {},
    weight: {}
  },
  setup(n) {
    const s = n, { bind: r, weight: e } = L(s);
    return (V, a) => (t(), l("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(r)), [
      p(V.$slots, "default"),
      o(e) === "bold" ? (t(), l("g", Z, a[0] || (a[0] = [
        H("path", { d: "M240,204H228V144a12,12,0,0,0,12.49-19.78L142.14,25.85a20,20,0,0,0-28.28,0L15.51,124.2A12,12,0,0,0,28,144v60H16a12,12,0,0,0,0,24H240a12,12,0,0,0,0-24ZM52,121.65l76-76,76,76V204H164V152a12,12,0,0,0-12-12H104a12,12,0,0,0-12,12v52H52ZM140,204H116V164h24Z" }, null, -1)
      ]))) : o(e) === "duotone" ? (t(), l("g", m, a[1] || (a[1] = [
        H("path", {
          d: "M216,116.69V216H152V152H104v64H40V116.69l82.34-82.35a8,8,0,0,1,11.32,0Z",
          opacity: "0.2"
        }, null, -1),
        H("path", { d: "M240,208H224V136l2.34,2.34A8,8,0,0,0,237.66,127L139.31,28.68a16,16,0,0,0-22.62,0L18.34,127a8,8,0,0,0,11.32,11.31L32,136v72H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM48,120l80-80,80,80v88H160V152a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H48Zm96,88H112V160h32Z" }, null, -1)
      ]))) : o(e) === "fill" ? (t(), l("g", v, a[2] || (a[2] = [
        H("path", { d: "M240,208H224V136l2.34,2.34A8,8,0,0,0,237.66,127L139.31,28.68a16,16,0,0,0-22.62,0L18.34,127a8,8,0,0,0,11.32,11.31L32,136v72H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Zm-88,0H104V160a4,4,0,0,1,4-4h40a4,4,0,0,1,4,4Z" }, null, -1)
      ]))) : o(e) === "light" ? (t(), l("g", M, a[3] || (a[3] = [
        H("path", { d: "M240,210H222V131.17l5.76,5.76a6,6,0,0,0,8.48-8.49L137.9,30.09a14,14,0,0,0-19.8,0L19.76,128.44a6,6,0,0,0,8.48,8.49L34,131.17V210H16a6,6,0,0,0,0,12H240a6,6,0,0,0,0-12ZM46,119.17l80.58-80.59a2,2,0,0,1,2.84,0L210,119.17V210H158V152a6,6,0,0,0-6-6H104a6,6,0,0,0-6,6v58H46ZM146,210H110V158h36Z" }, null, -1)
      ]))) : o(e) === "regular" ? (t(), l("g", g, a[4] || (a[4] = [
        H("path", { d: "M240,208H224V136l2.34,2.34A8,8,0,0,0,237.66,127L139.31,28.68a16,16,0,0,0-22.62,0L18.34,127a8,8,0,0,0,11.32,11.31L32,136v72H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM48,120l80-80,80,80v88H160V152a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H48Zm96,88H112V160h32Z" }, null, -1)
      ]))) : o(e) === "thin" ? (t(), l("g", h, a[5] || (a[5] = [
        H("path", { d: "M240,212H220V126.34l9.17,9.17a4,4,0,1,0,5.66-5.66L136.49,31.51a12,12,0,0,0-17,0L21.17,129.85a4,4,0,1,0,5.66,5.66L36,126.34V212H16a4,4,0,0,0,0,8H240a4,4,0,0,0,0-8ZM44,118.34l81.17-81.17a4,4,0,0,1,5.66,0L212,118.34V212H156V152a4,4,0,0,0-4-4H104a4,4,0,0,0-4,4v60H44ZM148,212H108V156h40Z" }, null, -1)
      ]))) : u("", !0)
    ], 16));
  }
});
export {
  y as default
};
